import { Apple, Play } from "lucide-react";

export function AppStoreButtons({ className = "" }) {
  return (
    <div className={`flex flex-col sm:flex-row gap-3 ${className}`}>
      <a
        href="#"
        data-testid="download-app-store"
        aria-label="Download on the App Store"
        className="group inline-flex items-center gap-3 rounded-full bg-foreground text-background px-6 py-3.5 transition-all hover:opacity-90 active:scale-[0.98]"
      >
        <Apple className="h-5 w-5" strokeWidth={1.5} />
        <span className="flex flex-col leading-tight text-left">
          <span className="text-[10px] font-mono uppercase tracking-widest opacity-70">
            Download on
          </span>
          <span className="text-sm font-medium tracking-tight">App Store</span>
        </span>
      </a>
      <a
        href="#"
        data-testid="download-play-store"
        aria-label="Get it on Google Play"
        className="group inline-flex items-center gap-3 rounded-full border border-border bg-transparent text-foreground px-6 py-3.5 transition-all hover:bg-secondary active:scale-[0.98]"
      >
        <Play className="h-5 w-5" strokeWidth={1.5} />
        <span className="flex flex-col leading-tight text-left">
          <span className="text-[10px] font-mono uppercase tracking-widest text-secondary">
            Get it on
          </span>
          <span className="text-sm font-medium tracking-tight">Google Play</span>
        </span>
      </a>
    </div>
  );
}
